import React from 'react'
import reactStamp from 'react-stamp'
import './side-panel.css'

export default reactStamp(React).compose({

    render() {
        if (this.props.active) {
            return (
                <div className="side-panel-item active" onClick={()=>{this.props.onclick()}}>
                    <h3 className="label">{this.props.name}</h3>
                </div>
            )
        } else {
            return (
                <div className="side-panel-item" onClick={()=>this.props.onclick()}>
                    <h3 className="label">{this.props.name}</h3>
                </div>
            )
        }
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/SidePanel/SidePanelItem.js
 **/